var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Config } from '../../config/config';
var ReleaseService = (function () {
    function ReleaseService() {
        this.flags = Config.getEnvironmentVariable('releaseFlags');
    }
    ReleaseService.prototype.getFlag = function (name) {
        return typeof this.flags[name] == 'undefined' ? false : this.flags[name];
    };
    ReleaseService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], ReleaseService);
    return ReleaseService;
}());
export { ReleaseService };
//# sourceMappingURL=release.service.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/features/release.service.js
// module id = 543
// module chunks = 0